/* @jsxImportSource @emotion/react */

import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'

import { ImgSanity } from '@slite/components'

type FeaturesImageTabsProps = {
  className?: string
  defaultActiveTab: string
  data: {
    id: string
    label: React.ReactNode
    imageSrc: string
  }[]
}

export const FeaturesImageTabs = ({
  className,
  data,
  defaultActiveTab,
}: FeaturesImageTabsProps) => {
  const [activeTab, setActiveTab] = React.useState(defaultActiveTab)

  const activeTabData = data.find((item) => item.id === activeTab)

  return (
    <div
      className={classNames(
        'padding-top-16 flexbox flexbox-column flexbox-centered',
        className
      )}
    >
      <div className="flexbox flexbox-align-center flexbox-column-gap-8 margin-bottom-32">
        {data.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setActiveTab(item.id)}
            className={classNames(
              'background-transparent font-size-4 font-family-title padding-horizontal-16 padding-vertical-12 radius-largest font-weight-medium pointer transition font-size-7-small',
              activeTab === item.id
                ? 'shade-05 border-small border-shade-05'
                : 'shade-20 border-small border-transparent border-shade-30-on-hover'
            )}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div
        css={css`
          position: relative;
          border-radius: 8px;

          &:before {
            position: absolute;
            content: '';
            display: block;
            width: calc(100% + 12px);
            height: calc(100% + 6px);
            border: 1px solid var(--shade-05);
            border-radius: 8px;
            top: -6px;
            left: -6px;
          }
        `}
      >
        <ImgSanity
          css={css`
            border-radius: 4px;
          `}
          className="display-block"
          alt=""
          src={activeTabData?.imageSrc || ''}
        />
      </div>
    </div>
  )
}
